<template>
 <div class="py-1">
        <div class="w-full flex">
           <div class="w-1/2 pt-2 text-lg pl-1">
                Profesores
           </div>
           <div v-if="canManageTeachers" class="w-1/2 flex border-white border-b-4 border-solid justify-end ">
                <button @click="goTo('createTeacher')" class="px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700">
                    Agregar Profesor
                </button>
           </div>
        </div>

        <div class="my-3 flex flex-wrap gap-3 items-end bg-white rounded-md shadow px-4 py-3">
            <div class="w-full sm:w-40">
                <label class="block text-xs font-medium text-gray-500 mb-1">Nombre</label>
                <input
                    v-model="filters.firstname"
                    type="text"
                    class="w-full border border-gray-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:border-indigo-600"
                    placeholder="Nombre"
                    @keyup.enter="getTeachers"
                />
            </div>
            <div class="w-full sm:w-40">
                <label class="block text-xs font-medium text-gray-500 mb-1">Apellido</label>
                <input
                    v-model="filters.lastname"
                    type="text"
                    class="w-full border border-gray-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:border-indigo-600"
                    placeholder="Apellido"
                    @keyup.enter="getTeachers"
                />
            </div>
            <div class="w-full sm:w-32">
                <label class="block text-xs font-medium text-gray-500 mb-1">DNI</label>
                <input
                    v-model="filters.dni"
                    type="text"
                    class="w-full border border-gray-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:border-indigo-600"
                    placeholder="DNI"
                    @keyup.enter="getTeachers"
                />
            </div>
            <div class="w-full sm:w-36">
                <label class="block text-xs font-medium text-gray-500 mb-1">Estado</label>
                <select
                    v-model="filters.status"
                    class="w-full border border-gray-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:border-indigo-600"
                >
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                </select>
            </div>
            <div class="flex gap-2">
                <button
                    type="button"
                    @click="getTeachers"
                    class="px-3 py-2 text-gray-100 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 text-sm"
                >
                    Buscar
                </button>
                <button
                    type="button"
                    @click="resetFilters"
                    class="px-3 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none text-sm"
                >
                    Limpiar
                </button>
            </div>
        </div>

        <div v-if="teachers.length === 0" class="my-2 bg-gray-50 border border-gray-200 rounded-md p-6 text-center text-gray-600 text-sm">
            No hay profesores para los filtros seleccionados.
        </div>

        <div v-if="teachers.length > 0">
            <div class="my-2 overflow-hidden bg-white rounded-md shadow">
                <table class="w-full text-left border-collapse">
                    <thead class="border-b">
                        <tr class="py-5 text-sm font-medium  text-gray-100 bg-indigo-800">
                            <th
                            class="px-5 py-2"
                            >
                            Apellido y Nombre
                            </th>

                            <th class="px-5 py-2">
                                DNI
                            </th>
                            <th class="px-5 py-2">
                                CUIL
                            </th>
                            <th class="px-5 py-2">
                                Teléfono
                            </th>
                            <th class="px-5 py-2">
                                Email
                            </th>
                            <th class="px-5 py-2">
                                Estado
                            </th>
                            <th class="px-5 py-2">
                                Horario
                            </th>

                            <!-- Actions -->
                            <th class="px-5 py-2">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(teacher, index) in teachers"
                        :key="index"
                        class="hover:bg-gray-200 text-sm"
                        >
                        <td class="px-5 py-2  text-gray-700 border-b">
                        {{ teacher.Profile.lastname }}, {{ teacher.Profile.firstname }}
                        </td>
                        <td class="px-5 py-2 text-gray-500 border-b">
                        {{ teacher.Profile.dni }}
                        </td>
                        <td class="px-5 py-3 text-gray-500 border-b">
                            {{ teacher.Profile.cuil }}
                        </td>
                        <td class="px-5 py-3 text-gray-500 border-b">
                            {{ teacher.Profile.phone }}
                        </td>

                        <td class="px-5 py-3 text-gray-500 border-b">
                            {{ teacher.email }}
                        </td>

                        <td class="px-5 py-3 text-gray-500 border-b">
                            <div class="inline-flex items-center gap-2">
                                <span
                                    class="font-medium"
                                    :class="teacherStatus(teacher) === 'activo' ? 'text-green-700' : 'text-red-600'"
                                >
                                    {{ statusLabel(teacher) }}
                                </span>
                                <button
                                    v-if="canChangeUserStatus"
                                    type="button"
                                    title="Editar estado"
                                    class="text-indigo-500 hover:text-indigo-800 hover:bg-gray-100 p-1 rounded-md"
                                    @click="openStatusModal(teacher)"
                                >
                                    <font-awesome-icon :icon="['fas', 'file-pen']" class="text-lg" />
                                </button>
                            </div>
                        </td>

                        <td class="px-5 py-3 text-gray-500 border-b">
                            <button
                                type="button"
                                class="text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 px-3 py-1.5 rounded-md text-sm font-medium inline-flex items-center"
                                @click="openScheduleModal(teacher)"
                            >
                                <font-awesome-icon :icon="['fas', 'calendar-check']" class="mr-2" />
                                Ver horario
                            </button>
                        </td>

                        <!-- icons actions -->
                        <td class="px-2 py-3 text-left text-gray-500 border-b">
                           <!-- icon edit -->
                           <a v-if="canManageTeachers" href="#" @click.prevent="editUser(teacher.id)"
                             class="text-indigo-500 hover:text-indigo-800 hover:bg-gray-100 px-3 py-2 rounded-md text-base font-medium">
                            <font-awesome-icon :icon="['fas', 'file-pen']" class="text-prired  mx-0  md::mx-2 text-xl   cursor-pointer hover:text-red-400" />
                           </a>

                           <!-- icon delete -->
                           <!-- <a href="#" class="text-red-500 hover:text-indigo-800 hover:bg-gray-100 px-3 py-2 rounded-md text-base font-medium">
                                <font-awesome-icon :icon="['fas', 'trash-can']"  class="text-prired  mx-0  md::mx-2 text-xl   cursor-pointer hover:text-red-400" />
                            </a> -->
                        </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <TeacherSchedule
            v-if="scheduleTeacherId"
            :teacher-id="scheduleTeacherId"
            :teacher-name="scheduleTeacherName"
            as-modal
            :visible="scheduleModalVisible"
            @close="closeScheduleModal"
        />

        <div
            v-if="statusModalVisible"
            class="fixed inset-0 z-50 flex items-center justify-center bg-gray-600 bg-opacity-50 p-4"
            @click.self="closeStatusModal"
        >
            <div
                class="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden"
                role="dialog"
                aria-modal="true"
                aria-labelledby="status-modal-title"
            >
                <div class="px-6 py-4 border-b border-gray-200">
                    <h2 id="status-modal-title" class="text-lg font-semibold text-gray-800">
                        Cambiar estado del profesor
                    </h2>
                    <p class="mt-1 text-sm text-gray-600">
                        Editando estado de
                        <span class="font-medium text-gray-800">{{ statusEditTeacherName }}</span>
                    </p>
                </div>
                <div class="px-6 py-4">
                    <label class="block text-xs font-medium text-gray-500 mb-1">Estado</label>
                    <select
                        v-model="statusEditValue"
                        :disabled="statusSaving"
                        class="w-full border border-gray-200 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:border-indigo-600 disabled:opacity-50"
                    >
                        <option value="activo">Activo</option>
                        <option value="inactivo">Inactivo</option>
                    </select>
                </div>
                <div class="px-6 py-4 bg-gray-100 flex justify-end gap-2">
                    <button
                        type="button"
                        :disabled="statusSaving"
                        class="px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
                        @click="closeStatusModal"
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        :disabled="statusSaving"
                        class="px-4 py-2 text-sm text-gray-100 bg-gray-800 rounded-md hover:bg-gray-700 disabled:opacity-50"
                        @click="saveTeacherStatus"
                    >
                        {{ statusSaving ? 'Guardando…' : 'Guardar' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import TeacherSchedule from '@/components/schedule/TeacherSchedule.vue'

export default {
    name:'Teacher',
    components: { TeacherSchedule },
    data(){
        return{
            teachers: [],
            filters: {
                firstname: '',
                lastname: '',
                dni: '',
                status: 'activo',
            },
            scheduleModalVisible: false,
            scheduleTeacherId: null,
            scheduleTeacherName: '',
            statusModalVisible: false,
            statusEditTeacher: null,
            statusEditValue: 'activo',
            statusSaving: false,
        }
    },
    computed: {
        ...mapGetters('authentication', ['currentUser']),
        statusEditTeacherName() {
            if (!this.statusEditTeacher?.Profile) return ''
            const p = this.statusEditTeacher.Profile
            return `${p.lastname}, ${p.firstname}`
        },
        canManageTeachers() {
            const r = this.currentUser?.role
            return ['admin', 'executive', 'director'].includes(r)
        },
        canChangeUserStatus() {
            const r = this.currentUser?.role
            return ['admin', 'executive', 'director', 'administrative'].includes(r)
        },
    },
    created(){
        this.getTeachers()
    },
    methods: {
        teacherUserId(teacher) {
            return teacher.User?.id ?? teacher.user_id ?? teacher.id
        },
        openScheduleModal(teacher) {
            this.scheduleTeacherName = `${teacher.Profile.lastname}, ${teacher.Profile.firstname}`
            this.scheduleTeacherId = this.teacherUserId(teacher)
            this.scheduleModalVisible = true
        },
        closeScheduleModal() {
            this.scheduleModalVisible = false
            this.scheduleTeacherId = null
            this.scheduleTeacherName = ''
        },
        editUser(id){
            this.$router.push(`/teachers/edit/${id}`)
        },
        teacherStatus(teacher) {
            return teacher.status === 'inactivo' ? 'inactivo' : 'activo'
        },
        statusLabel(teacher) {
            return this.teacherStatus(teacher) === 'activo' ? 'Activo' : 'Inactivo'
        },
        openStatusModal(teacher) {
            this.statusEditTeacher = teacher
            this.statusEditValue = this.teacherStatus(teacher)
            this.statusModalVisible = true
        },
        closeStatusModal() {
            this.statusModalVisible = false
            this.statusEditTeacher = null
            this.statusEditValue = 'activo'
        },
        async saveTeacherStatus() {
            const teacher = this.statusEditTeacher
            if (!teacher) return
            const userId = this.teacherUserId(teacher)
            const next = this.statusEditValue
            if (this.teacherStatus(teacher) === next) {
                this.closeStatusModal()
                return
            }
            this.statusSaving = true
            try {
                await this.$http.patch(`/users/${userId}/status`, { status: next })
                teacher.status = next
                if (this.filters.status && this.filters.status !== next) {
                    this.teachers = this.teachers.filter(
                        (t) => this.teacherUserId(t) !== userId
                    )
                }
                this.closeStatusModal()
            } catch (err) {
                console.log(err)
                const msg = err.response?.data?.message || 'No se pudo actualizar el estado del usuario.'
                window.alert(msg)
            } finally {
                this.statusSaving = false
            }
        },
        teacherListParams() {
            const params = { status: this.filters.status || 'activo' }
            const firstname = this.filters.firstname?.trim()
            const lastname = this.filters.lastname?.trim()
            const dni = this.filters.dni?.trim()
            if (firstname) params.firstname = firstname
            if (lastname) params.lastname = lastname
            if (dni) params.dni = dni
            return params
        },
        resetFilters() {
            this.filters = {
                firstname: '',
                lastname: '',
                dni: '',
                status: 'activo',
            }
            this.getTeachers()
        },
        getTeachers(){
            this.$http.get('/teachers', { params: this.teacherListParams() })
            .then( res => {
                this.teachers = (res.data.data) ? res.data.data : []
            })
            .catch( err => console.log(err))
        },
        goTo(item, id = null){
            switch (item) {
                case 'createTeacher':
                    this.$router.push(`/teachers/create`)
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style>

</style>